export { ConnectedThumbnailCarousel } from './ConnectedThumbnailCarousel'
export type { ConnectedThumbnailCarouselOnClickArgs } from './ConnectedThumbnailCarousel'
